import {makeAutoObservable} from "mobx";
import {api, catchApi,} from "../../api";
import {SalutationTypeDto, UserDetailDto, UserGroupTypeDto} from "../../api/ums";
import {FormData} from "../../components/page/ums/UserForm";
import {validationStore} from "../ValidationStore";

class UserCreateStore {


    get group(): UserGroupTypeDto | null {
        return this._group;
    }

    set group(value: UserGroupTypeDto | null) {
        this._group = value;
    }

    get email(): string {
        return this._email;
    }

    set email(value: string) {
        this._email = value;
    }

    get firstname(): string {
        return this._firstname;
    }

    set firstname(value: string) {
        this._firstname = value;
    }

    get lastname(): string {
        return this._lastname;
    }

    set lastname(value: string) {
        this._lastname = value;
    }

    get salutation(): SalutationTypeDto | null {
        return this._salutation;
    }

    set salutation(value: SalutationTypeDto | null) {
        this._salutation = value;
    }

    get phoneNumber(): string {
        return this._phoneNumber;
    }

    set phoneNumber(value: string) {
        this._phoneNumber = value;
    }

    get remark(): string {
        return this._remark;
    }

    set remark(value: string) {
        this._remark = value;
    }

    get creating(): boolean {
        return this._creating;
    }

    set creating(value: boolean) {
        this._creating = value;
    }

    get valid(): boolean {
        return this._valid;
    }

    set valid(value: boolean) {
        this._valid = value;
    }

    private _group: UserGroupTypeDto | null = null;
    private _email: string = ''
    private _firstname: string = ''
    private _lastname: string = ''
    private _salutation: SalutationTypeDto | null = null
    private _phoneNumber: string = ''
    private _remark: string = ''



    private _creating: boolean = false
    private _valid: boolean = false

    get formData(): FormData {
        return {
            salutation: this.salutation,
            lastname: this.lastname,
            firstname: this.firstname,
            email: this.email,
            phoneNumber: this.phoneNumber,
            remark: this.remark,
            group: this.group,
        }
    }

    set formData({
                     salutation,
                     lastname,
                     firstname,
                     email,
                     phoneNumber,
                     remark,
                     group
                 }: FormData) {
        this.salutation = salutation
        this.lastname = lastname
        this.firstname = firstname
        this.email = email
        this.phoneNumber = phoneNumber
        this.remark = remark
        this.group = group
    }

    constructor() {
        makeAutoObservable(this)
    }

    async create() {
        const dto = this.buildDto()
        return await catchApi(async () => {
            return await api.ums.api.createUser(dto)
        })
    }

    async validate() {
        const dto = this.buildDto()
        await validationStore.validateWithQuery(api.ums.api.validateUser, dto, {validateEmail: true})
        this.valid = Boolean(validationStore.valid)
    }

    reset() {
        this.email = ''
        this.firstname = ''
        this.lastname = ''
        this.salutation = null
        this.phoneNumber = ''
        this.remark = ''
    }

    private buildDto(): UserDetailDto {
        const {
            email,
            firstname,
            lastname,
            salutation,
            remark,
            phoneNumber,
            group,
        } = this
        return {
            active: false,
            group: group!!,
            email,
            firstname,
            lastname,
            salutation: salutation || undefined,
            phoneNumber,
            remark
        }
    }
}

const userCreateStore = new UserCreateStore()

export {
    userCreateStore
}
